export default __webpack_public_path__ + "static/media/bg1.6531858b.png";